import { cached, tracked } from '@glimmer/tracking';
import type { PropertyRowDataItem } from 'uplisting-frontend/services/calendar/data';
import { OccasionDto } from 'uplisting-frontend/services/calendar/-internals/dto';
import { OccasionMeta } from 'uplisting-frontend/services/calendar/-internals/meta';

interface IOccasionRecord {
  model: PropertyRowDataItem;
  dto: OccasionDto;
  meta: OccasionMeta;
}

export class OccasionRecord implements IOccasionRecord {
  @cached @tracked dto!: OccasionDto;
  @cached @tracked meta!: OccasionMeta;
  @cached @tracked model!: PropertyRowDataItem;

  constructor(context, model: PropertyRowDataItem) {
    this.model = model;

    this.dto = new OccasionDto(context, model);
    this.meta = new OccasionMeta(context, model);
  }
}
